import React from "react";
import PropTypes from "prop-types";

import "apps/messenger/components/Connections/shared/Header.scss";

function Header({ children }) {
	return (
		<div className="connection-header">
			{ children }
		</div>
	);
}

Header.propTypes = {
	children: PropTypes.node.isRequired,
};


export default Header;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/shared/Header.jsx